export default __webpack_public_path__ + "static/LeituraSansTwo-BoldItalic-f0905e2d22d3154068ceaef42c1cdeeb.woff";